import { Controller } from '@hotwired/stimulus'

// Поле «Город» в форме создания матча (account/matches/new.slim) — то же
// устройство, что у tournament_club_controller.js (клубы в конструкторе
// турниров), но выбор пишет ещё и id в скрытое поле (city_id) — ради часового
// пояса города (UserMatch#match_time_zone). Выбирать из подсказок не
// обязательно: города нет в каталоге — текст поля сохранится в city_name,
// а время матча возьмётся в поясе устройства.
export default class MatchCityController extends Controller {
  static targets = ['input', 'hiddenId', 'dropdown']
  static values = { url: String }

  connect() {
    this.onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    document.addEventListener('click', this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener('click', this.onDocumentClick)
    clearTimeout(this.timer)
  }

  // Ручная правка текста делает прежний выбор недостоверным: id мог
  // указывать на город с другим написанием.
  inputChanged() {
    // Сообщаем о сбросе пояса только если город был выбран: иначе каждая
    // нажатая клавиша заново пересчитывала бы список времени.
    if (this.hiddenIdTarget.value) this.announce(null)
    this.hiddenIdTarget.value = ''
    this.search()
  }

  // Пояс выбранного города — для match_start_controller.js: прошедшие
  // получасы считаются в поясе города матча, а не устройства.
  announce(timeZone) {
    this.element.dispatchEvent(
      new CustomEvent('match-city:picked', {
        bubbles: true,
        detail: { timeZone }
      })
    )
  }

  // Выбран клуб из каталога в поле «Где» (tournament_club_controller.js) —
  // город берём его: так пояс времени тоже совпадёт с клубом.
  fillFromClub(event) {
    const { city } = event.detail
    this.cancelSearch()
    this.inputTarget.value = city.name
    this.hiddenIdTarget.value = city.id
    this.announce(city.time_zone)
    this.close()
  }

  cancelSearch() {
    clearTimeout(this.timer)
    this.lastRequestId = (this.lastRequestId || 0) + 1
  }

  search() {
    // Любое изменение текста обесценивает запрос в полёте: иначе при
    // сокращении до одного символа его ответ снова раскрыл бы старые города.
    this.cancelSearch()
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.close()
      return
    }
    this.timer = setTimeout(() => this.fetchSuggestions(query), 300)
  }

  async fetchSuggestions(query) {
    const requestId = this.lastRequestId
    try {
      const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      if (requestId !== this.lastRequestId || !response.ok) return

      const data = await response.json()
      if (requestId !== this.lastRequestId) return
      this.render(data.suggestions || [])
    } catch {
      if (requestId === this.lastRequestId) this.close()
    }
  }

  render(suggestions) {
    if (!suggestions.length) {
      this.close()
      return
    }

    this.dropdownTarget.innerHTML = ''
    suggestions.forEach(({ id, name, label, time_zone: timeZone }) => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'tournament-club-suggestion'
      item.textContent = label
      item.addEventListener('click', () => {
        this.inputTarget.value = name
        this.hiddenIdTarget.value = id
        this.announce(timeZone)
        this.close()
      })
      this.dropdownTarget.appendChild(item)
    })
    this.dropdownTarget.classList.remove('hidden')
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
    this.dropdownTarget.innerHTML = ''
  }
}
